import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopUpCardComponent } from './pop-up-card.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { TabHolderDirective } from './tab-holder.directive';



@NgModule({
    declarations: [
        PopUpCardComponent,
        TabHolderDirective
    ],
    imports: [
        CommonModule,
        MatTabsModule,
        MatButtonModule,
        MatDialogModule
    ],
    exports: [
        PopUpCardComponent
    ]
})
export class PopUpCardModule { }
